const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const OpsUser = require("../../core/vault/OpsUser");
const OpsCart = require("../vault/OpsCart");
const _ = require("lodash");
const URLMake = require("../../../shared/URLMake");
const styles = require("./styles/PageRedeemSubscription.css");
const CopyTable = require("../data/CopyTable");
// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "RedeemSubscriptionConfirmation",

		propTypes: {
			user: PT.object.isRequired,
			cart: PT.object.isRequired,
			onRestartFlow: PT.func.isRequired,
			dispatch: PT.func.isRequired, // Injected by HOCs
		},

		renderLoggedOut: function() {
			const {email} = OpsCart.getFormSection(this.props.cart, "account");
			const redeemCodeCopy = CopyTable.getRedeemConfirmationStepCopy(
				{email},
				styles
			);
			return (
				<div className={styles.sectionWrapper}>
					<h2 className={styles.title}>{redeemCodeCopy.newParentTitle}</h2>
					<div className={styles.bodyText}>
						{redeemCodeCopy.newParentDescription}
					</div>
					<div className={styles.bodyText}>
						{redeemCodeCopy.newParentHelpText}
					</div>
				</div>
			);
		},

		renderLoggedIn: function() {
			const studentData = _.get(
				this.props.cart,
				"redeemSubscriptionStudentData",
				{}
			);
			const redeemCodeCopy = CopyTable.getRedeemConfirmationStepCopy(
				{studentName: studentData.name},
				styles
			);
			return (
				<div className={styles.sectionWrapper}>
					<h2 className={styles.title}>{redeemCodeCopy.existingParentTitle}</h2>
					<div className={styles.bodyText}>
						{redeemCodeCopy.existingParentDescription}
					</div>
					<div className={styles.buttonsContainerVertical}>
						<a href={URLMake.forAccount()} className={styles.primaryButton}>
							Go To Account
						</a>
						<button
							className={styles.secondaryButton}
							onClick={this.props.onRestartFlow}
						>
							+ Add another code
						</button>
					</div>
				</div>
			);
		},

		render: function() {
			const {user} = this.props;
			const isLoggedIn = OpsUser.isLoggedIn(user);
			return isLoggedIn ? this.renderLoggedIn() : this.renderLoggedOut();
		},
	})
);
